import { FC } from 'react';

import { Routes, Route } from 'react-router-dom';

import { AnswerCheck } from 'components/pages/AnswerCheck';
import { AnswerResult } from 'components/pages/AnswerResult';
import { Area } from 'components/pages/Area';
import { AreaDetail } from 'components/pages/AreaDetail';
import { Card } from 'components/pages/Card';
import { CardFailure } from 'components/pages/CardFailure';
import { CardSuccess } from 'components/pages/CardSuccess';
import { ClueCheck } from 'components/pages/ClueCheck';
import { ClueResult } from 'components/pages/ClueResult';
import { Ending } from 'components/pages/Ending';
import { Home } from 'components/pages/Home';
import { Info } from 'components/pages/Info';
import { Menu } from 'components/pages/Menu';
import { News } from 'components/pages/News';
import { Plays } from 'components/pages/Plays';
import { Prizes } from 'components/pages/Prizes';
import { PrizesCompleted } from 'components/pages/PrizesCompleted';
import { Redirect } from 'components/pages/Redirect';
import { Reward } from 'components/pages/Reward';
import { RewardFailure } from 'components/pages/RewardFailure';
import { RewardSuccess } from 'components/pages/RewardSuccess';
import { Starting } from 'components/pages/Starting';
import { Story } from 'components/pages/Story';
import { Tutorial } from 'components/pages/Tutorial';

import { Layout } from 'components/features/Layout';
import { AuthLiffGuard } from 'guard/AuthLiffGuard';
import { OnBoardingGuard } from 'guard/OnBoardingGuard';
import { MissionCheck } from 'components/pages/MissionCheck';
import { MissionResult } from 'components/pages/MissionResult';

export const Private: FC = () => {
  return (
    <Routes>
      <Route element={<AuthLiffGuard />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Starting />} />
          <Route path="/story" element={<Story />} />
          <Route path="/story/:id" element={<Story />} />
          <Route element={<OnBoardingGuard />}>
            <Route path="/redirect" element={<Redirect />} />
            <Route path="/home" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/menu/info" element={<Info />} />
            <Route path="/menu/news" element={<News />} />
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/play" element={<Plays />} />
            <Route path="/ending" element={<Ending />} />
            <Route path="/area" element={<Area />} />
            <Route path="/area/:id" element={<AreaDetail />} />
            <Route path="/area/clue/:area" element={<ClueCheck />} />
            <Route path="/area/clue-result/:id" element={<ClueResult />} />
            <Route path="/area/answer/:id" element={<AnswerCheck />} />
            <Route path="/area/answer-result/:id" element={<AnswerResult />} />
            <Route path="/mission/answer/:id" element={<MissionCheck />} />
            <Route path="/mission/answer-result/:id" element={<MissionResult />} />
            <Route path="/prizes" element={<Prizes />} />
            <Route path="/prizes/completed/:id" element={<PrizesCompleted />} />
            <Route path="/card" element={<Card />} />
            <Route path="/card/success/:id" element={<CardSuccess />} />
            <Route path="/card/failure" element={<CardFailure />} />
            <Route path="/reward/:id" element={<Reward />} />
            <Route path="/reward/success/:id" element={<RewardSuccess />} />
            <Route path="/reward/failure/:id" element={<RewardFailure />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
